import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/template/BatteryHealthIframe/BatteryHealthIframe.tsx");
